/* PROJ-96 V5 (20.10.2026): 3D-Bühne der Konfiguratoren (jewelry-stage.js) für die PDP-Personalisierung der
   Fußabdruck Kette. Dominik 20.10.: in der Galerie soll die Kette so erscheinen wie im Konfigurator
   (/pages/fussabdruck-kette-gestalten), mit Kette, Öse und Anhänger, nicht als flacher Coin.
   Dünner Modul-Wrapper, weil assets/abdruck-pdp.js ein klassisches Script ist: stellt window.DLAbdruckBuehne bereit
   und meldet 'dl-abdruck-buehne-bereit'. ?v wie in jewelry-abdruck.js (Shopify-CDN cacht den unversionierten Pfad). */
import { erstelleBuehne } from './jewelry-stage.js?v=37';

window.DLAbdruckBuehne = {
  erstelle(host, { hdrUrl, farbe, aktiveSeite, blick }) {
    /* blick: Kamera weiter weg als im Konfigurator (quadratisches Galeriebild statt hoher Bühne), sonst wird der
       Anhänger unten angeschnitten. window.DL_ABDRUCK_BLICK nur für Prüfstände. */
    return erstelleBuehne({ stage: host, hdrUrl, startFarbe: farbe, fallbackAlt: 'Vorschau deiner Gravur', aktiveSeite,
      blick: window.DL_ABDRUCK_BLICK || blick });
  },
};
document.dispatchEvent(new CustomEvent('dl-abdruck-buehne-bereit'));
